import React,{useState} from 'react';
import { Link,useNavigate } from 'react-router-dom';
import VideoServices from '../../../services/VideoServices';
function AddVideo() {

  
  const [formValues, setFormValues] = useState({
    title: '',
    link: '',
  });
const navigate = useNavigate();


  // Handle form input changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      console.log(formData);
    for (const key in formValues) {
      formData.append(key, formValues[key]);
    }
      console.log(formValues)
     const response = await VideoServices.createVideo(formValues);
      // Assuming updateContactDetail is a method in UserServices
//  console.log(response);
      alert('Video Added Successfully');
      navigate('/admin/video')
      } catch (error) {
      console.error('Failed to Video details', error);
      alert('Failed to add Video details');
    }
  };

  return (
    <>
    <div className="right_col" role="main">
        <div className="title-box">
          <h2>Video Add</h2>
          <div className="container-box-top-header-right">
            <Link className="list-banner-btn" to="/admin/video">Video List</Link>
          </div>
        </div>
        <div className="container-box px-5">
          <div className="container-box-inner">
            <div className="page-details">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-9 col-md-6">
                    <div className="input-field">
                      <label>Tittle</label>
                      <input type="text" name="title" className="form-control"  value={formValues.title} 
                        onChange={handleInputChange}  placeholder="New video" />
                    </div>
                  </div>
                 
                  <div className="col-lg-12 col-md-6">
                    <div className="input-field">
                      <label>Link</label>
                      <input type="text" name="link" className="form-control"  value={formValues.link} 
                        onChange={handleInputChange}  placeholder="New video" />
                    </div>
                  </div>
                
                </div>
                <button className="submit-green-btn">Submit</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AddVideo